<!-- 商家销量统计的横向柱状图
     数据从小到大排序，每5个元素显示一页
	 客户数统计
 -->
<template>
	<div class="com-container">
		<!-- 真正显示图表的div -->
		<div class="com-chart" ref="seller_ref"></div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				chartInstance: null,
				allData: null, // 服务器返回的数据
				currentPage: 1, // 当前显示的页数  通过定时器来决定当前显示第几页
				totalPage: 0, // 一共有多少页    通过计算来获取
				timerId: null, // 定时器的标识  用于取消定时器
				// allData: [{
				// 	"name": "商家1",
				// 	"value": 99
				// }, {
				// 	"name": "商家2",
				// 	"value": 102
				// }, {
				// 	"name": "商家3",
				// 	"value": 83
				// }, {
				// 	"name": "商家4",
				// 	"value": 49
				// }, {
				// 	"name": "商家5",
				// 	"value": 200
				// }, {
				// 	"name": "商家6",
				// 	"value": 152
				// }, {
				// 	"name": "商家7",
				// 	"value": 76
				// }, {
				// 	"name": "商家8",
				// 	"value": 23
				// }, {
				// 	"name": "商家9",
				// 	"value": 87
				// }, {
				// 	"name": "商家10",
				// 	"value": 223
				// }, {
				// 	"name": "商家11",
				// 	"value": 145
				// }, {
				// 	"name": "商家12",
				// 	"value": 187
				// }, {
				// 	"name": "商家13",
				// 	"value": 127
				// }, {
				// 	"name": "商家14",
				// 	"value": 57
				// }, {
				// 	"name": "商家15",
				// 	"value": 99
				// }]
			}
		},
		mounted() {
			this.initChart()
			this.getData()
			window.addEventListener('resize', this.screenAdapter)
			// 在页面加载完成的时候, 主动进行屏幕的适配
			this.screenAdapter()
		},
		destroyed() { // 在组件销毁的时候
			clearInterval(this.timerId) // 定时器取消
			// 将监听器取消掉
			window.removeEventListener('resize', this.screenAdapter)
		},
		methods: {
			// 1、初始化echartInstance对象
			initChart() {
				// this.chartInstance = this.echarts.init(this.$refs.seller_ref)
				// this.chartInstance = this.echarts.init(this.$refs.seller_ref,'vintage')
				this.chartInstance = this.echarts.init(this.$refs.seller_ref, 'chalk')
				// 对图表对象进行鼠标事件的监听
				this.chartInstance.on('mouseover', () => { // 鼠标移入
					clearInterval(this.timerId)
				})
				this.chartInstance.on('mouseout', () => { // 鼠标移出
					this.startInterval()
				})
			},
			// 2、获取服务器的数据   async getData() {
			getData() {
				this.getRequest('/work_log/header_index1').then(resp => {
					if (resp) {
						// alert(JSON.stringify(resp.data))
						this.allData = resp.data    // 这行切换静态数据与动态数据
						// 对数据排序
						this.allData.sort((a, b) => {
							// return a.custNum - b.custNum // 从小到大的排序  
							return b.custNum - a.custNum // 从大到小的排序  
							// return a.value - b.value  //静态数据 从小到大的排序  
						})
						// 若每5个元素显示一页，计算总页数
						this.totalPage = this.allData.length % 5 === 0 ? this.allData.length / 5 : this.allData
							.length / 5 + 1 // 若能被5整除 数组长度/5  否则 （数组长度/5） + 1
						this.updateChart() // 第一次 更新图表
						this.startInterval() // 启动定时器 每隔3秒更新图表
					}
				})
			},
			// 3、更新图表
			updateChart() {
				const start = (this.currentPage - 1) * 5
				const end = this.currentPage * 5
				const showData = this.allData.slice(start, end) // showData 从allData中取其中一部分来展示 ； 采用 slice 对数组 某些元素进行截取
				// const showData = this.allData     

				const sellerNames = showData.map((item) => {
					return item.userName
					return item.name  //静态数据
				})
				const sellerValues = showData.map((item) => {
					return item.custNum
					// return item.value  //静态数据
				})
				// alert("sellerNames="+sellerNames)
				// alert("sellerValues="+sellerValues)
				const titleFontSize = this.$refs.seller_ref.offsetWidth / 100 *
					3.6 //  this.$refs.seller_ref.offsetWidth 是图表容器的宽度

				const dataOption = {
					// 标题
					title: {
						text: '▎客户数量统计',
						textStyle: {
							fontSize: titleFontSize
						},
						left: 20,
						top: 20
					},
					// 直角坐标系 控制整个坐标轴的大小
					grid: {
						top: '20%',
						left: '3%',
						right: '6%',
						bottom: '3%',
						containLabel: true // 距离是包含坐标轴上的文字
					},
					xAxis: {
						type: 'value' // 数据轴
					},
					yAxis: {
						type: 'category', // 类目轴
						data: sellerNames,

					},
					tooltip: { // 鼠标接触柱子出现提示信息 且出现柱子的背景色  工具提示
						trigger: 'axis', // 鼠标接触到坐标轴时触发
						axisPointer: {
							type: 'line', //背景是条线
							z: 0, // 将背景色的层级降到0 这样背景颜色就不会覆盖柱子
							lineStyle: {
								width: titleFontSize, //背景线的宽度
								color: '#2D3443' //背景颜色
							}
						}
					},
					series: [{
						type: 'bar', // 柱状图
						data: sellerValues, // 数据轴上的数据
						barWidth: titleFontSize, // 柱子的宽度
						label: { // 柱子上的文字
							show: true,
							position: 'right', //默认显示在柱子的内部
							textStyle: {
								color: 'white'
							}
						},
						itemStyle: { //柱子的样式
							barBorderRadius: [0, titleFontSize / 2, titleFontSize / 2,
							0], // 设置柱子的圆角  左上角、右上角、左下角、右下角 的半径
							// 指明颜色渐变的方向   四个值分别是 x1,y1,x2,y2 分别代表(x1,y1) (x2,y2) 两个点； （0,0）代表矩形的左上角即坐标原点   ； （1,0）代表矩形的右上角 ；  （0,1）代表矩形的左下角； （1,1）代表矩形的右下角；
							// 0, 0, 1, 0 ==>从左向右的方向    0,0,0,1 ==> 从上向下的方向
							// 指明不同百分比之下颜色的值
							color: new this.echarts.graphic.LinearGradient(0, 0, 1, 0, [ // 控制每根柱子颜色渐变
								// 百分之0状态之下的颜色值
								{
									offset: 0,
									color: '#5052EE'
								},
								// 百分之100状态之下的颜色值
								{
									offset: 1,
									color: '#AB6EE5'
								}
							])
						}

					}]
				}
				this.chartInstance.setOption(dataOption)
			},
			startInterval() {
				if (this.timerId) { // 启动定时器之前 保险起见 先判断定时器是否存在，若存在清除（取消）定时器，后面开启新的定时器
					clearInterval(this.timerId)
				}
				this.timerId = setInterval(() => { // 每隔3秒的定时器   触发后做 更改图表当前显示的页 同时调用更新图表数据
					this.currentPage++
					if (this.currentPage > this.totalPage) {
						this.currentPage = 1
					}
					this.updateChart()
				}, 3000)
			},
			// 当浏览器的大小发生变化的时候, 会调用的方法, 来完成屏幕的适配
			screenAdapter() {
				// console.log(this.$refs.seller_ref.offsetWidth)
				const titleFontSize = this.$refs.seller_ref.offsetWidth / 100 * 3.6
				// 和分辨率大小相关的配置项
				const adapterOption = {
					title: {
						textStyle: {
							fontSize: titleFontSize
						}
					},
					tooltip: {
						axisPointer: {
							lineStyle: {
								width: titleFontSize
							}
						}
					},
					series: [{
						barWidth: titleFontSize,
						itemStyle: {
							barBorderRadius: [0, titleFontSize / 2, titleFontSize / 2, 0]
						}
					}]
				}
				this.chartInstance.setOption(adapterOption)
				// 手动的调用图表对象的resize 才能产生效果
				this.chartInstance.resize()
			}
		}
	}
</script>

<style lang="less" scoped>
</style>
